<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="emergencyCalls"
      :items="emergencyCalls"
      :fields="emergencyCallsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedEmergencyCalls"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      emergencyCallsFields: [
        {key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'zonesDirections', label: this.$i18n.t('Zones/directions'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedEmergencyCalls: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedEmergencyCalls = {
        service_id: -1,
        tel_directions: [],
        id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditEmergencyCalls', '#btnShow')
    },
    editItem (item) {
      this.selectedEmergencyCalls = JSON.parse(JSON.stringify(item))
      if (this.selectedEmergencyCalls.service_id === this.$i18n.t('All')) {
        this.selectedEmergencyCalls.service_id = 0
      }
      this.selectedEmergencyCalls.id = 1
      this.$root.$emit('bv::show::modal', 'modalEditEmergencyCalls', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Emergency calls"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let sID = item.service_id === this.$i18n.t('All') ? 0 : item.service_id
      let response = this.$store.dispatch('Settings/DELETE_EMERGENCY_CALLS', sID)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_EMERGENCY_CALLS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    emergencyCalls () {
      let telZones = this.$store.getters['Tariffing/TEL_ZONES']
      let telDirections = this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'].items
      let services = this.$store.getters['Tariffing/SERVICES']
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/EMERGENCY_CALLS']))
      for (let el of copy) {
        if (el.service_id === 0) {
          el.service_id = this.$i18n.t('All')
          el.name = '---'
          break
        }
      }
      for (let el of copy) {
        for (let serviceEl of services) {
          if (el.service_id === serviceEl.service_id) {
            el.name = serviceEl.service_name
          }
        }
      }
      for (let copyEl of copy) {
        copyEl.zonesDirections = ''
        for (let el of copyEl.tel_directions) {
          for (let zonesEl of telZones) {
            if (el.direction === zonesEl.zone_id) {
              if (copyEl.zonesDirections.length) {
                copyEl.zonesDirections += '; '
              }
              copyEl.zonesDirections += zonesEl.name
            }
          }
          for (let directionsEl of telDirections) {
            if (el.direction === directionsEl.dir_id) {
              if (copyEl.zonesDirections.length) {
                copyEl.zonesDirections += '; '
              }
              copyEl.zonesDirections += directionsEl.name
            }
          }
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_EMERGENCY_CALLS')
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Tariffing/GET_TEL_ZONES')
    this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': 20, 'offset': 0, 'filter': ''})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/emergencyCalls/main.vue